<template>
  <section class="section projet" id="projet">
    <div class="padtop">
      <div class="container">
        <div class="columns">
          <div class="column is-two-thirds">
            <!-- <figure class="image">
            <img src="../assets/vrexample.jpg" />
          </figure> -->
            <div data-aos="zoom-in" data-aos-delay="300">
              <div class="wraplogo">
                <figure class="image">
                  <img src="../assets/img/logo_itwa.png" alt="logo It4Anxiety wallon"/>
                </figure>
              </div>
            </div>
          </div>
          <div class="column">
            <h2 class="title has-text-primary" data-aos="fade-left" data-aos-delay="300">Le Projet</h2>
            <p class="is-size-5" data-aos="fade-left" data-aos-delay="450">
              IT4Anxiety est un projet européen qui cherche à
              <b>aider les patients</b> souffrant de la maladie d’Alzheimer ou
              de stress post-traumatique à gérer leur anxiété plus efficacement
              en développant des
              <b>innovations technologiques et des e-thérapies.</b>
            </p>
          </div>
        </div>
        <!-- <div class="intermede">
        
      </div> -->
        <div class="columns">
          <div class="column is-one-quarter">
            <div class="has-text-primary">
              <div class="exergue" data-aos="fade-left">
                <p class="is-size-3-desktop is-size-3-mobile is-size-4-tablet is-size-2-fullhd has-text-centered has-text-weight-bold">
                  Le pouvoir des technologies face à l'anxiété
                </p>
              </div>
            </div>
          </div>
          <div class="column is-three-quarters illustration">
            <img src="../assets/img/vrexample.jpg" alt="personnes agées utilisant un casque de réalité virtuelle" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      rellax: {
        speed: -10,
      },
    };
  },
};
</script>

<style lang="scss">
.wraplogo {
  width: 50%;
  margin: auto;
}

.founders {
}

.illustration {
  img {
    display: block;
    width: 100%;
  }
}
</style>